import React from "react";
import Splides from './components/Splides';
import Info from './components/Info';
import Video from './components/Video';

function App() {

  return (
    <div className="page-container">
      <div className="d-none d-md-flex w-100 shadow z50k">
        <Info extraClass="overflow-scroll vh-100 p-3 p-lg-4"/>
      </div>
      <div>
        <Splides/>
        <div className="container border-end border-start d-flex d-md-none">
          <Info extraClass="p-0"/>
        </div>
        <div className="container border-end border-start py-4">
          <span className="fs-7 text-gold fw-lighter letter-spacing-lg">BD6018</span>
          <h2 className="text-body fw-normal mb-4">ABOUT THE PROJECT</h2>
          <Video/>
          <p>You are looking at one of my projects Kite De Modular, which was inspired by Tom's house by Anna-Marie Chin Architects and Koto cabins by Koto Design. Kite is a small prefab house with an area of 12.5 * 4.6 m built by Modulo. The roof is designed with the ridge located on the diagonal instead of in the middle of the house (like the structure of a kite). The unique roof creates interesting intersections inside the house.</p>
          <p>How interesting?</p>
          <p>Find out for yourself, hope you enjoy Kite.</p>
          <p>Thanks for visiting</p>
          <p className="fs-7 text-gold fw-bold"><i>Click image below to view detail or download my poster</i></p>
          <a style={{ width: 'max(200px, min(15vw, 325px))' }} className="d-flex" href="/images/BD6018_POSTER.png" target="_blank">
            <img className="w-75" src="/images/poster_thumbnail.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
